module.exports = __webpack_public_path__ + "img/journey1-B.9523ecde.png";